module.exports = __webpack_public_path__ + "img/img1_6.6d7b0a08.jpeg";